import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Column, Row } from '../layout';
import styled from '../../styles/styled';
import { createTestIdFunc } from '../../util/attribute';
const Headline = styled.div `
    font-size: ${props => props.theme.text.size[props.size]};
    font-family: ${props => props.theme.text.headingFontFamily};
    font-weight: 500;
    text-transform: none;
    word-break: break-word;
    color: ${props => props.theme.text.color[props.color]};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: normal;
`;
const Subhead = styled.div `
    font-family: ${props => props.theme.text.bodyFontFamily};
    font-size: 1rem;
    font-weight: 400;
    color: ${props => props.theme.text.color[props.color]};
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: normal;
`;
export const ListRowFeaturedCell = ({ headline, subHeadline, subHeadlineColor = 'grey90', headlineColor = 'grey90', headlineSize = 'mediumLarge', testid = 'listrow-featured-cell', monochrome, maskHeadline = false, maskSubHeadline = false, ...columnProps }) => {
    const testId = createTestIdFunc(testid);
    return (_jsxs(Column, { ...columnProps, children: [_jsx(Row, { "data-testid": testId(), marginBottom: '5px', children: _jsx(Headline, { "data-testid": testId('headline'), color: headlineColor, size: headlineSize, ...{ [maskHeadline ? 'data-clarity-mask' : 'data-clarity-unmask']: 'true' }, children: headline }) }), _jsx(Subhead, { "data-testid": testId('subhead'), color: subHeadlineColor, monochrome: monochrome, ...{ [maskSubHeadline ? 'data-clarity-mask' : 'data-clarity-unmask']: 'true' }, children: subHeadline })] }));
};
//# sourceMappingURL=featured_cell.js.map